export const validationErrorMessage = {
  EMPTY_LASTNAME: 'Veuillez renseigner votre nom',
  EMPTY_FIRSTNAME: 'Veuillez renseigner votre prénom',
  EMPTY_BIRTHDATE: 'Veuillez renseigner votre date de naissance',
  EMPTY_POSTALCODE: 'Veuillez renseigner votre code postal',
  EMPTY_EMAIL: 'Veuillez renseigner votre adresse email',
  EMPTY_PHONE: 'Veuillez renseigner votre numéro de téléphone portable',
  MAX_32_CHAR: '32 caractères maximum',
  MAX_50_CHAR: '50 caractères maximum',
  INVALID_ACCOUNT_TYPE: 'Selectionner le type de compte',
  INVALID_CIVILITY: 'Veuillez renseigner votre état civil',
  INVALID_DATE: "La date saisie n'est pas valide",
  INVALID_POSTALCODE_FORMAT: 'votre code postal doit comporter 5 chiffres',
  INVALID_PHONE:
    'Un numéro de téléphone portable en France doit commencer par 06 ou 07 et comporter 10 chiffres',
  INVALID_FORMAT: 'Format incorrect',
  MINOR: 'Vous devez être majeur pour souscrire',
  ONLY_METROPOLITAN_FRANCE:
    "La souscription d'un compte bancaire est réservée aux résidants de France métropolitaine.",
}
